module.exports = __webpack_public_path__ + "static/media/599.7554(28).aa7b6118.pdf";